












































































































import {
  getSalaryItemListApi,
  createSalaryItemApi,
  deleteSalaryItemApi,
  setSalaryItemStatusApi,
  setSalaryItemSortApi,
} from "@/api/salary";
import { NonRelativeModuleNameResolutionCache } from "typescript";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  staticList: any[] = [];
  customList: any[] = [];
  adding: boolean = false;
  addForm = {
    type: 1,
    name: "",
  };
  dialogVisible: boolean = false;
  newValue: any = "";
  oldValue: any = "";
  // 当移动移入某个元素时触发
  dragover(e: any) {
    if (this.adding) return;
    // 禁止默认事件触发
    e.preventDefault();
  }
  // 鼠标拖动当前元素时触发
  dragstart(v: any) {
    if (this.adding) return;
    this.oldValue = v;
  }
  // 鼠标松开进入某个容器时触发
  dragenter(v: any, e: any) {
    if (this.adding) return;
    this.newValue = v;
  }
  // 鼠标完成拖动后触发
  dragend(v: any, e: any) {
    if (this.adding) return;
    // eslint-disable-next-line no-useless-return
    if (this.newValue === this.oldValue) return;
    // 拿到旧节点index
    const oldIndex = this.customList.indexOf(this.oldValue);
    // 拿到新节点index
    const newIndex = this.customList.indexOf(this.newValue);
    this.customList.splice(oldIndex, 1); // 先删
    this.customList.splice(newIndex, 0, this.oldValue); // 再增
    const newArr: any = this.customList.map((item: any) => {
      return {
        salary_item_id: item.salary_item_id,
      };
    });
    const obj: any = {
      item_list: newArr,
    };
    setSalaryItemSortApi(obj).then((res: any) => {
      if (res.error_code === 0) {
        this.$message({
          type: "success",
          message: "排序成功",
        });
      }
    });
  }
  init() {
    this.addForm = {
      type: 1,
      name: "",
    };
    getSalaryItemListApi().then((res: any) => {
      const staticList: any[] = [];
      const customList: any[] = [];
      res.data.list.map((item: any) => {
        item.status = item.status === 1;
        if (item.preset_id > 0) {
          staticList.push(item);
        } else {
          customList.push(item);
        }
      });
      this.staticList = staticList;
      this.customList = customList;
    });
  }
  openDialog() {
    this.init();
    this.dialogVisible = true;
  }
  closeDialog() {
    this.dialogVisible = false;
    this.$emit("close");
  }
  handleAdd() {
    this.adding = true;
  }
  handleSaveAdd() {
    if (!this.addForm.name) {
      this.$message({
        type: "warning",
        message: "请先填写工资条项目名称",
      });
      return false;
    }
    createSalaryItemApi({
      type: this.addForm.type,
      name: this.addForm.name,
    }).then(() => {
      this.$message({
        type: "success",
        message: "添加成功",
      });
      this.adding = false;
      this.init();
    });
  }
  handleCancelAdd() {
    this.adding = false;
    this.addForm = { type: 1, name: "" };
  }
  handleDelete(data: { salary_item_id: number }) {
    deleteSalaryItemApi({ salary_item_id: data.salary_item_id }).then(() => {
      this.$message({
        type: "success",
        message: "删除成功",
      });
      this.init();
    });
  }
  handleItemStatusChange(v: boolean, data: { salary_item_id: number }) {
    setSalaryItemStatusApi({
      salary_item_id: data.salary_item_id,
      status: v ? 1 : 2,
    })
      .then(() => {
        this.$message({
          type: "success",
          message: "修改成功",
        });
        this.init();
      })
      .catch(() => {
        this.init();
      });
  }
}
